// Almata Partner Constants
export const GET_ALMATA_PARTNERS_REQUEST = 'GET_ALMATA_PARTNERS_REQUEST';
export const GET_ALMATA_PARTNERS_SUCCESS = 'GET_ALMATA_PARTNERS_SUCCESS';
export const GET_ALMATA_PARTNERS_FAILURE = 'GET_ALMATA_PARTNERS_FAILURE';

export const ADD_ALMATA_PARTNER_REQUEST = 'ADD_ALMATA_PARTNER_REQUEST';
export const ADD_ALMATA_PARTNER_SUCCESS = 'ADD_ALMATA_PARTNER_SUCCESS';
export const ADD_ALMATA_PARTNER_FAILURE = 'ADD_ALMATA_PARTNER_FAILURE';

export const EDIT_ALMATA_PARTNER_REQUEST = 'EDIT_ALMATA_PARTNER_REQUEST';
export const EDIT_ALMATA_PARTNER_SUCCESS = 'EDIT_ALMATA_PARTNER_SUCCESS';
export const EDIT_ALMATA_PARTNER_FAILURE = 'EDIT_ALMATA_PARTNER_FAILURE';

export const DELETE_ALMATA_PARTNER_REQUEST = 'DELETE_ALMATA_PARTNER_REQUEST';
export const DELETE_ALMATA_PARTNER_SUCCESS = 'DELETE_ALMATA_PARTNER_SUCCESS';
export const DELETE_ALMATA_PARTNER_FAILURE = 'DELETE_ALMATA_PARTNER_FAILURE';

export const CHANGE_ALMATA_STATUS_REQUEST = 'CHANGE_ALMATA_STATUS_REQUEST';
export const CHANGE_ALMATA_STATUS_SUCCESS = 'CHANGE_ALMATA_STATUS_SUCCESS';
export const CHANGE_ALMATA_STATUS_FAILURE = 'CHANGE_ALMATA_STATUS_FAILURE';

export const GET_ALMATA_SCAN_TYPES_REQUEST = 'GET_ALMATA_SCAN_TYPES_REQUEST';
export const GET_ALMATA_SCAN_TYPES_SUCCESS = 'GET_ALMATA_SCAN_TYPES_SUCCESS';
export const GET_ALMATA_SCAN_TYPES_FAILURE = 'GET_ALMATA_SCAN_TYPES_FAILURE';

export const GET_OEM_PARTNERS_REQUEST = 'GET_OEM_PARTNERS_REQUEST';
export const GET_OEM_PARTNERS_SUCCESS = 'GET_OEM_PARTNERS_SUCCESS';
export const GET_OEM_PARTNERS_FAILURE = 'GET_OEM_PARTNERS_FAILURE';

export const GET_OEM_PARTNER_USERS_REQUEST = 'GET_OEM_PARTNER_USERS_REQUEST';
export const GET_OEM_PARTNER_USERS_SUCCESS = 'GET_OEM_PARTNER_USERS_SUCCESS';
export const GET_OEM_PARTNER_USERS_FAILURE = 'GET_OEM_PARTNER_USERS_FAILURE';

export const CLEAR_ALMATA_SUCCESS = 'CLEAR_ALMATA_SUCCESS';
export const CLEAR_ALMATA_ERROR = 'CLEAR_ALMATA_ERROR';

export const RESET_ALMATA_PASSWORD_REQUEST = 'RESET_ALMATA_PASSWORD_REQUEST';
export const RESET_ALMATA_PASSWORD_SUCCESS = 'RESET_ALMATA_PASSWORD_SUCCESS';
export const RESET_ALMATA_PASSWORD_FAILURE = 'RESET_ALMATA_PASSWORD_FAILURE';

export const RESEND_ALMATA_VERIFICATION_EMAIL_REQUEST = 'RESEND_ALMATA_VERIFICATION_EMAIL_REQUEST';
export const RESEND_ALMATA_VERIFICATION_EMAIL_SUCCESS = 'RESEND_ALMATA_VERIFICATION_EMAIL_SUCCESS';
export const RESEND_ALMATA_VERIFICATION_EMAIL_FAILURE = 'RESEND_ALMATA_VERIFICATION_EMAIL_FAILURE';